import { LottieRefCurrentProps } from 'lottie-react';
import { useRef } from 'react';

const useLottieHandlers = () => {
	const lottieRef = useRef<LottieRefCurrentProps | null>(null);

	const playAnimHandler = () => {
		if (!lottieRef.current) return;

		lottieRef.current.play();
	};

	const stopAnimHandler = () => {
		if (!lottieRef.current) return;

		lottieRef.current.stop();
	};

	const playForwardAnimHandler = () => {
		if (!lottieRef.current) return;

		lottieRef.current.setDirection(1);
		playAnimHandler();
	};

	const playBackAnimHandler = () => {
		if (!lottieRef.current) return;

		lottieRef.current.setDirection(-1);
		playAnimHandler();
	};

	const setSpeedHandler = (speed: number) => {
		if (!lottieRef.current) return;

		lottieRef.current.setSpeed(speed);
	};

	return {
		lottieRef,
		playAnimHandler,
		stopAnimHandler,
		playForwardAnimHandler,
		playBackAnimHandler,
		setSpeedHandler
	};
};

export default useLottieHandlers;
